import type { IconProps } from '../types/IconProps.ts';
export const Equal: IconProps = {
    name: 'Equal',
    children: [
        `<path d="M5 15h14M5 9h14" />`,
    ]
};